import Layout from "../../shared/Layout"
import { GetProductOrderSummary } from "../../../_services";
import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import './ProductReport.css';
import TopSection from "./TopSection";
import { Rate } from "antd";
import { handleExport } from "../../../_services/excelExportService";

const ProductReport = () => {
    const [productOrderData, setProductOrderData] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [totalProductSale, setTotalProductSale] = useState(0);
    const [totalDiscount, setTotalDiscount] = useState(0);

    const fetchProductOrderSummary = async () => {
        try {
            const response = await GetProductOrderSummary();

            if (response.isSuccess === 200) {
                const orders = response.data;
                const sanitizedOrders = orders.map(order => ({
                    ...order,
                    totalAmount: parseFloat(order.totalAmount) || 0,
                    totalDiscount: parseFloat(order.totalDiscount) || 0,
                }));

                const total = sanitizedOrders.reduce(
                    (sum, order) => sum + order.totalAmount,
                    0
                );

                const totalDiscounts = sanitizedOrders.reduce(
                    (sum, order) => sum + order.totalDiscount,
                    0
                );

                setTotalDiscount(totalDiscounts)
                setTotalProductSale(total)
                setProductOrderData((prevData) => {
                    if (JSON.stringify(prevData) !== JSON.stringify(orders)) {
                        const sortedData = orders?.sort((a, b) => {
                            return new Date(b.createdDate) - new Date(a.createdDate);
                        });
    
                        return sortedData;
                    }
                    return prevData;
                })

            } else {
                setError(response.message || 'Login failed. Please check your credentials.');
            }
        } catch (error) {
            setError('An error occurred. Please try again later.');
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchProductOrderSummary();
    }, []);

    useEffect(() => {
        if (searchTerm) {
            const filtered = productOrderData.filter(item => {
                const searchValue = searchTerm.toLowerCase();
                return (
                    item.productName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    item.unitPrice.toString().toLowerCase().includes(searchValue) ||
                    item.totalOrderAmount.toString().toLowerCase().includes(searchValue) ||
                    item.totalQuantity.toString().toLowerCase().includes(searchValue)
                );
            });
            setFilteredData(filtered);
        } else {
            setFilteredData(productOrderData);
        }
    }, [searchTerm, productOrderData]);

    const excelSheetData = productOrderData.map((item, index) => ({
        Index: index + 1,
        ProductName: item.productName,
        ProductUnitPrice: item.unitPrice,
        TotalAmountSold: item.totalAmount,
        TotalQuantitySold: item.totalQuantity,
        avgRating: item.avgRating,
    }));

    const columns = [
        {
            name: 'S.No',
            selector: (row, index) => index + 1,
            sortable: false,
            width: '70px'
        },
        {
            name: 'Product Name',
            cell: row => row.productName,
            sortable: false
        },
        {
            name: 'Product Unit Price',
            cell: row => row.unitPrice,
            sortable: false
        },
        {
            name: 'Total Amount Sold',
            cell: row => row.totalOrderAmount,
            sortable: false
        },
        {
            name: 'Total Quantity Sold',
            cell: row => row.totalQuantity,
            sortable: false
        },
        {
            name: 'Average Ratings',
            cell: row => (
                <div className="d-flex align-items-center" style={{ gap: '3px' }}>
                    <Rate
                        allowHalf={true}
                        disabled
                        value={1}
                        count={1}
                        className="reating_star"
                    />
                    <span>{row.avgRating}</span>
                    <span>{` (5)`}</span>
                </div>
            ),
            sortable: false
        }
    ];

    return (
        <Layout>
            <div className="px-4 my-4 order_report_wepper">
                <div className="admin-page d-sm-flex justify-content-between align-items-center">
                    <div className="admin-heading d-flex align-items-center" style={{ gap: "10px" }}>
                        <img src="./images/seller_sale.png" style={{ width: '25px' }} alt="" />
                        <h4 className="mb-0">Product Report</h4>
                    </div>
                </div>
                {/* <div className="card">
                    <div className="card-body">
                        <h4 className="mb-3">Filter Data</h4>
                    </div>
                    <div className="row">
                        <div className="col-lg-3 col-md-4 col-sm-3">
                            <select name="cars" id="cars">
                                <option value="This Year">This Year</option>
                                <option value="saab">Saab</option>
                                <option value="opel">Opel</option>
                                <option value="audi">Audi</option>
                            </select>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-3">
                            <button type="submit" className="filter_btn">
                                Filter
                            </button>
                        </div>
                    </div>
                </div> */}
                <TopSection
                    productOrderData={productOrderData}
                    totalProductSale={totalProductSale}
                    totalDiscounts={totalDiscount}
                />
                <div className="datatable mt-4">

                    <>
                        <div className="d-flex justify-content-between">
                            <div className="d-flex align-items-center mb-3" style={{ gap: '10px' }}>
                                <h5 className="mb-0">Total Orders</h5>
                                <span className="order_length">{productOrderData?.length}</span>
                            </div>
                            <div className="d-flex align-items-center" style={{ gap: '10px' }}>
                                <div className="search-container ">
                                    <input
                                        type="text"
                                        placeholder="Search..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        className="form-control"
                                    />
                                </div>
                                <button className="export_button" onClick={() => handleExport(excelSheetData)}><img src="./images/upload.png" alt="" className="export_icon" /><span>Export</span></button>
                            </div>
                        </div>
                        <DataTable
                            columns={columns}
                            data={filteredData || []}
                            progressPending={loading}
                            progressComponent={<p>Loading...</p>}
                            pagination
                            highlightOnHover
                        />
                    </>

                </div>
            </div>
        </Layout>
    )
}
export default ProductReport